import { Text, ThirdPartyButton } from 'shell/components';

const ThirdPartyButtonDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>ThirdPartyButton</Text>
            <ThirdPartyButton variant={'google'} onClick={() => console.log('google')} />
            <ThirdPartyButton variant={'google'} onClick={() => console.log('google')} disabled />
        </>
    );
};

export default ThirdPartyButtonDemo;
